import React from "react";
import ReactDOM from "react-dom";
import App from "./js/App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter as Router, Route } from "react-router-dom";

import "./sass/style.scss";
import "./sass/themes/layout/header/base/light.scss";
import "./sass/themes/layout/header/menu/light.scss";
import "./sass/themes/layout/aside/dark.scss";
import "./sass/themes/layout/brand/dark.scss";
import "./plugins/fontawesome4/scss/font-awesome.scss";
import "./plugins/flaticon2/flaticon.css";

ReactDOM.render(
  <>
    <Router>
      <Route component={App} />
    </Router>
  </>,
  document.getElementById("root")
);

serviceWorker.unregister();
